import React from 'react';

const NoWater = props => (
  <svg
    width={37}
    height={38}
    viewBox="0 0 37 38"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M26.95 22.976c0 5.24-4.193 9.487-9.37 9.487-5.176 0-9.37-4.248-9.37-9.487C8.21 17.736 17.58 4 17.58 4s9.37 13.737 9.37 18.976Z"
      stroke="#BCC6CA"
      strokeLinejoin="round"
    />
    <path
      d="M17.07 27.365c-2.412 0-4.369-1.983-4.369-4.425"
      stroke="#BCC6CA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4 34 33.313 4.338" stroke="#647A85" strokeWidth={5.04} strokeLinecap="square" />
    <path d="M4 34 33.313 4.338" stroke="#BCC6CA" strokeLinecap="square" />
  </svg>
);

export default NoWater;
